import { Component, OnInit} from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import { LookupService } from '../../services/lookup.service';
import { BuildingService } from '../../services/building.service';
import { SharedService } from '../../services/shared.service';
import { BuildingQuestionParam } from '../../viewmodel';
import { AddBuildingForm } from '../../viewmodel';
import { FoucsChangeService } from '../../services/focuschange.service';

@Component({
    selector: 'app-addbuilding',
    templateUrl: './addbuilding.component.html',
    providers: [BuildingService],
    animations: [
        trigger(
            'enterAnimation', [
                transition(':enter', [
                    style({ transform: 'translateX(100%)', opacity: 0 }),
                    animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ transform: 'translateX(0)', opacity: 1 }),
                    animate('500ms', style({ transform: 'translateX(100%)', opacity: 0 }))
                ])
            ]
        )
    ]
})
export class AddbuildingComponent implements OnInit {

    title: string = 'Add Building';
    projectId: number = 0;
    isVerified: boolean;
    verifyClicked: boolean;
    showNewStreetTextBox: boolean = false; 
    submitted: boolean;
    buildingForm: FormGroup;
    model: AddBuildingForm; 
    boroughs: any;
    pageError: any = [];
    pageSuccess: any = [];
    streets: Array<any> = [];
    _newStConst = '__enternewst';
    isAppEditable: boolean = false; 
    showNotFoundPopup: boolean = false;  

    constructor(private formBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private lookupService: LookupService
        , private buildingService: BuildingService
        , private sharedService: SharedService
        , private foucsChangeService: FoucsChangeService
        , private router: Router) {

        this.model = new AddBuildingForm();
    }

    ngOnInit() {
               
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = this.model.ProjectId = ids.projectId;
            }          
        }
        if (this.projectId <= 0) {
            this.sharedService.navigateHome();
        }
        
        this.isVerified = false;
        this.verifyClicked = false;
        this.submitted = false;
        this.buildingForm = this.formBuilder.group({
            ProjectId: [this.projectId],
            Borough: [null, [Validators.required]],
            Block: [null, [Validators.required, Validators.min(1), Validators.max(99999), Validators.pattern("[0-9][0-9]{0,4}?")]],
            Lot: [null, [Validators.required, Validators.min(1), Validators.max(9999), Validators.pattern("[0-9][0-9]{0,3}?")]],
            Phn: [null, [Validators.required, Validators.min(1), Validators.pattern("(^[a-zA-Z0-9]+(-{0,1})[a-zA-Z0-9]+|^[a-zA-Z0-9])$")]],
            Street: [null, [Validators.required]],
            NewStreet: ['', [Validators.pattern("(^[\-a-zA-Z0-9 ]+)$")]] 
        })

        this.lookupService.getLookups('Boro')
            .subscribe(
            successResp => {
                if (!successResp.Success)
                    this.showError(successResp.StatusMessage);
                else 
                    this.boroughs = successResp.Result
            },
            error => {               
                this.showError(error.ExceptionMessage);
            });  

    }


    verifyAgain() {
        this.isVerified = false;
        this.model.NewStreetName = ''; 
        this.showNewStreetTextBox = false;
    }
    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    verify() {
        
        this.verifyClicked = true;
        this.pageError = []; // Clear error        
        this.buildingForm.controls['Phn'].setValue('');
        this.buildingForm.controls["Street"].setValue('');
        this.streets = [];        

        if (this.buildingForm.controls['Borough'].value == null || this.buildingForm.controls['Borough'].value == '' ||
            this.buildingForm.controls['Block'].value == null || this.buildingForm.controls['Block'].value == '' ||
            this.buildingForm.controls['Lot'].value == null || this.buildingForm.controls['Lot'].value == '' ||
            this.buildingForm.controls['Block'].hasError('pattern') || this.buildingForm.controls['Lot'].hasError('pattern')) {
            return false;
        }  
        if (this.model.Lot == 0) {
            return false; 
        }
        if (this.model.Block == 0) {
            return false; 
        }
              

        this.buildingService.getBuildingsByBBL(this.buildingForm.controls['Borough'].value,
            this.buildingForm.controls['Block'].value,
            this.buildingForm.controls['Lot'].value)
            .subscribe(
            success => {
                if (!success.Success) {
                    if (success.StatusMessage != null && success.StatusMessage.indexOf('NoRecordFound') !== -1) {
                        //this.showErrorAlert("No record found.");
                        this.pageError = []; this.pageSuccess = [];
                        this.showNotFoundPopup = true;
                        this.foucsChangeService.changeFocus(false);
                    }
                    else {
                        this.showError(success.StatusMessage);
                    }
                }              
                else 
                {
                    this.isVerified = true;
                    this.streets = success.Result;                   
                    if (document.getElementById('phn') != null) {
                       setTimeout(function () {
                           document.getElementById('phn').focus();
                       }, 300); 
                    }                                        
                }
            },
            errorResp => {
                this.verifyClicked = true;
                this.isVerified = false;
                if (errorResp.StatusMessage != null && errorResp.StatusMessage.indexOf('NoRecordFound') !== -1) {  
                    this.pageError = []; this.pageSuccess = [];
                    this.showNotFoundPopup = true;
                    this.foucsChangeService.changeFocus(false);
                }
                else 
                    this.showError(errorResp.ExceptionMessage); 
            });
    }

    save(bType) {
        this.submitted = true; 
        var md = this.model; 
   
        if (md.StreetName === this._newStConst && md.NewStreetName != null) {
            if (md.NewStreetName.trim() == '') {
                this.model.NewStreetName = md.NewStreetName.trim();
                return;
            }
       }

        if (!this.buildingForm.valid) {
            return;
        } 

        this.buildingForm.value.NewStreet = this.buildingForm.value.NewStreet.replace(/  +/g, ' ').trim();       
        var addr = ''; 
        addr = this.getAddress(this.buildingForm.value.Phn, this.buildingForm.value.Street, this.buildingForm.value.NewStreet );
        this.buildingService.saveBuilding(this.buildingForm.value)
            .subscribe( 
            success => {
                if (!success.Success) {
                    if (success.StatusMessage != null && success.StatusMessage.indexOf('building has already been added') !== -1)
                        this.showErrorAlert(success.StatusMessage); 
                    else if (success.StatusMessage != null && success.StatusMessage.indexOf('NoRecordFound') !== -1) 
                    {
                         this.showErrorAlert('No Record Found');  
                    }
                    else 
                        this.showError(success.StatusMessage);                   
                }
                else {
                    if (success.Result != null) {
                        this.showSuccess('Saved Successfully!');
                        var ProjectDevBuilding = success.Result;    
                        if (bType == 'NEXT') {
                            var BQP = new BuildingQuestionParam();
                            BQP.devProjectBuildingId = ProjectDevBuilding.DevProjectBuildingID;                            
                            BQP.bldgId = ProjectDevBuilding.BldgID;
                            BQP.siteProjectBuildingId = null;
                            BQP.buildingAddress = addr; 
                            BQP.mood = 'A';    
                            this.sharedService.setJsonData('BuildingQuestionParam', BQP); 
                            this.router.navigate(['/buildings/unitcount'], { replaceUrl: true });
                        }
                        else if (bType == 'LATER') {
                            this.sharedService.navigateSummary();
                        }
                    }
                    else {
                        this.showErrorAlert(success.StatusMessage);
                    }
                }
            },
            error => {
		 if (!(error.ExceptionMessage != null && error.ExceptionMessage.indexOf('NoRecordFound') !== -1)) {
                	this.showError(error.ExceptionMessage);
		}
            })
    }

    changeStreetName() {
        var streetName = this.buildingForm.value.Street;
        if (streetName === this._newStConst) {
            this.showNewStreetTextBox = true;
        }
        else {
            this.showNewStreetTextBox = false;
            this.model.NewStreetName = ''; 
        }
    }

    validateNewStreet() {
        var result = (this.model.StreetName == this._newStConst && this.model.NewStreetName == '');
        if (result == true) 
            this.buildingForm.get('NewStreet').updateValueAndValidity();
        return result;
    }

    getAddress(phn, streetName, newStreet) {
        var addr = '';
        if (streetName == null)
            return '';

        if ( streetName == this._newStConst && !(newStreet == null || newStreet == '')) {
            streetName = newStreet; 
        }

        if (!(phn == null || phn == ''))
            addr = phn + ' ';
        if (streetName != null)
            addr += streetName;

        return addr;
    }

    hideBBLNotFoundPopup(event) {         
        this.showNotFoundPopup = false;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }

    previous() {
        this.sharedService.navigateSummary();
    }

    cancel() {
        this.sharedService.navigateSummary();
    }

    showError(msg) { 
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll(); 
    }   

}
